import { GCase, GGender, GNumber, TextWordNoun, TextWordType } from "@model";
import { getLemma } from "./word-tag.helper";

export function getNounGNumber(gNumber: string): GNumber {
  if (Object.values(GNumber).includes(gNumber as GNumber)) {
    return gNumber as GNumber;
  }
  console.warn("wrong grammatical number", gNumber);
  return GNumber.SINGULAR;
}

export function getNounGGender(gGender: string): GGender {
  if (Object.values(GGender).includes(gGender as GGender)) {
    return gGender as GGender;
  }
  console.warn("wrong grammatical gender", gGender);
  return GGender.M;
}

export function getNounGCase(gCase: string): GCase {
  if (Object.values(GCase).includes(gCase as GCase)) {
    return gCase as GCase;
  }
  console.warn("wrong grammatical case", gCase);
  return GCase.NOM;
}

export function findPropertiesForNoun(tag: string): TextWordNoun {
  // n_łóżko_sg_gen_n_łóżka
  const [,core] = tag.split("__");
  const [gNumber, gCase, gGender] = core.split("_");

  return {
    wordType: TextWordType.NOUN,
    gCore: core,
    lemma: getLemma(tag),
    gNumber: getNounGNumber(gNumber),
    gCase: getNounGCase(gCase),
    gGender: getNounGGender(gGender),
  };
}
